var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"d-front-page-custom relative"},[_c('HeroItem',{attrs:{"data":_vm.heroMedia,"pagetype":_vm.template,"autoplay":_vm.heroAutoplay}}),_vm._v(" "),_c('ContactButton',{attrs:{"content":_vm.contactpersons}}),_vm._v(" "),_c('BlockList',{attrs:{"block-list":_vm.contentElements}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }